import React from 'react';
import { motion } from 'framer-motion';
import { PROFILE_INFO } from '../data/profile';
import { SOCIAL_LINKS } from '../data/constants';
import { FileText } from 'lucide-react';

const Hero: React.FC = () => {
  return (
    <section className="screen-line-after px-4 py-16 md:py-24">
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="flex flex-col-reverse md:flex-row items-center md:items-start justify-between gap-10"
      >
        {/* Left - Text Content */}
        <div className="flex-1 flex flex-col gap-6 text-center md:text-left">
          {/* Name & Title */}
          <div className="space-y-3">
            <h1 className="text-3xl md:text-5xl font-bold tracking-tight text-foreground leading-tight">
              {PROFILE_INFO.displayName}
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground">
              {PROFILE_INFO.role}
            </p>
            <p className="text-sm text-muted-foreground font-mono">
              {PROFILE_INFO.slogan}
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-wrap justify-center md:justify-start gap-x-5 gap-y-2">
            {SOCIAL_LINKS.map((link) => (
              <a
                key={link.name}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-200 flex items-center gap-1.5"
              >
                <span>{link.name}</span>
                <span className="text-xs">↗</span>
              </a>
            ))}
            <a
              href={PROFILE_INFO.resumeUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-200 flex items-center gap-1.5"
            >
              <FileText size={14} />
              <span>Resume</span>
              <span className="text-xs">↗</span>
            </a>
          </div>
        </div>

        {/* Right - Profile Image */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.15 }}
          className="flex-shrink-0"
        >
          <div className="relative">
            <img
              src={PROFILE_INFO.profileImage}
              alt={PROFILE_INFO.displayName}
              className="w-56 h-72 md:w-64 md:h-80 object-cover object-top rounded-2xl border border-border shadow-lg"
            />
            {/* Subtle decorative accent */}
            <div className="absolute -inset-1 rounded-2xl border border-border opacity-30 -z-10" />
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hero;